export interface LocaleChangeParams {
  currentPath: string;
  newLocale: string;
  supportedLocales: string[];
}

export const createLocalizedPath = ({
  currentPath,
  newLocale,
  supportedLocales,
}: LocaleChangeParams): string => {
  const segments = currentPath.split("/").filter(Boolean);
  const isFirstSegmentLocale = supportedLocales.includes(segments[0]);
  const pathWithoutLocale = isFirstSegmentLocale
    ? segments.slice(1).join("/")
    : segments.join("/");

  return `/${newLocale}${pathWithoutLocale ? `/${pathWithoutLocale}` : ""}`;
};

export const getOptionKey = (
  arr: Record<string, string>[],
  value: string | undefined,
): string => {
  if (!Array.isArray(arr) || Array.length === 0 || !value) return "";
  return arr.find((item) => item.value === value)?.key || "";
};
